import { useApiClient } from '@/hooks'
import { unwrapErrorResponse, unwrapResponse } from '@/utils/unwrapResponse'
import { QuotationResearch, PostQuotationResearch } from '@/types/api/entities'
import { APIErrorResponse } from '@/types'
import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query'
import { getUseQuotationResearchKey } from '@/hooks'

export const usePostQuotationResearch = (
  quotationId: number
): UseMutationResult<
  QuotationResearch,
  APIErrorResponse,
  PostQuotationResearch
> => {
  const client = useApiClient()
  const queryClient = useQueryClient()

  return useMutation(
    (params) =>
      client
        .post(`/quotations/${quotationId}/researches/`, params)
        .then(unwrapResponse)
        .catch(unwrapErrorResponse),
    {
      onSuccess: (data) => {
        const queryKey = getUseQuotationResearchKey(quotationId, data.id)

        queryClient.setQueryData(queryKey, data)
      },
    }
  )
}
